// src/contexts/PageContext.tsx

import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
// import { getContentLibrary, updateQuickAccess } from '@/services/contentLibraryService';
// import toast from 'react-hot-toast';
import { Sidebar } from '@/components/layout/Sidebar';
interface Template {
  templateId: string;
  templateName: string;
  pageKey: string;
  isSinglePage: boolean;
  quickAccess: boolean;
}

interface PageContextType {
  currentPage: string;
  setCurrentPage: (page: string) => void;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  templates: Template[];
  // toggleQuickAccess: (pageKey: string) => Promise<void>;
  showHeader: boolean;
  setShowHeader: (show: boolean) => void;
  // refreshTemplates: () => Promise<void>;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

export const PageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('Dashboard');
  const [collapsed, setCollapsed] = useState(false);
  const [templates ] = useState<Template[]>([]);
  const [showHeader, setShowHeader] = useState(false);
  const location = useLocation();
  

  // const refreshTemplates = useCallback(async () => {
  //   setIsRefreshing(true);
  //   try {
  //     fetchTemplates()
  //   } catch (error) {
  //     console.error('Error refreshing templates:', error);
  //   } finally {
  //     setIsRefreshing(false);
  //   }
  // }, []);

  // Fetch templates and update state
  // const fetchTemplates = useCallback(async () => {
  //   const res = await getContentLibrary();
  //   if (res.success) {
  //     setTemplates(res.data);
  //   } else {
  //     setTemplates([]);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchTemplates();
  // }, [fetchTemplates]);

  // const toggleQuickAccess = async (pageKey: string) => {
  //   const res = await updateQuickAccess(pageKey);
  //   if (res.success) {
  //     toast.success(res.data);
  //     setTemplates(prevTemplates =>
  //       prevTemplates.map(template =>
  //         template.pageKey === pageKey
  //           ? { ...template, quickAccess: !template.quickAccess }
  //           : template
  //       )
  //     );
  //   }
  // };

  // Update current page and header visibility based on route
  useEffect(() => {
      // List pages where header should be shown
      const pagesWithHeader = [
        '/', 
        '/users',
        '/content-types', 
        '/pages', 
        '/settings', 
        '/profile',
        '/asset-manager',
        '/attribute-sets',
        '/content-library'
      ];
    const routeToPageName: { [key: string]: string } = {
      '/': 'Dashboard',
      '/users': 'Users Management',
      '/content-types': 'Content Types',
      '/pages': 'Pages',
      '/settings': 'Settings',
      '/profile': 'Profile Settings',
      '/support': 'Support Dashboard',
      '/asset-manager': 'Asset Manager',
      '/attribute-sets': 'Attribute Sets',
      '/content-library': 'Content Library',
    };
    const rootPath = '/' + location.pathname.split('/')[1];
    const pageName = routeToPageName[rootPath] || 'Unknown Page';

    // Set header visibility based on predefined pages
    setShowHeader(pagesWithHeader.includes(rootPath));
    setCurrentPage(pageName);
  }, [location]);

  return (
    <PageContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        collapsed,
        setCollapsed,
        templates,
        // toggleQuickAccess,
        showHeader,
        setShowHeader,
        // refreshTemplates
      }}
    >
      <main className="flex flex-col md:flex-row h-full">
        <Sidebar />
        <section className={`w-full flex-1 transition-all duration-200  ${collapsed ? 'pl-16' : 'pl-64'}`}>
          {children}
        </section>
      </main>
    </PageContext.Provider>
  );
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error('usePageContext must be used within a PageProvider');
  }
  return context;
};
